<template>
  <svg
    class="custom-icon"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4.44444C0 1.98985 1.98985 0 4.44444 0H10.6667C13.1213 0 15.1111 1.98985 15.1111 4.44444V10.6667C15.1111 13.1213 13.1213 15.1111 10.6667 15.1111H4.44444C1.98985 15.1111 0 13.1213 0 10.6667V4.44444Z"
    />
    <path
      d="M0 21.3333C0 18.8787 1.98985 16.8889 4.44444 16.8889H10.6667C13.1213 16.8889 15.1111 18.8787 15.1111 21.3333V27.5556C15.1111 30.0102 13.1213 32 10.6667 32H4.44444C1.98985 32 0 30.0102 0 27.5556V21.3333Z"
    />
    <path
      d="M16.8889 4.44444C16.8889 1.98985 18.8787 0 21.3333 0H27.5556C30.0102 0 32 1.98985 32 4.44444V10.6667C32 13.1213 30.0102 15.1111 27.5556 15.1111H21.3333C18.8787 15.1111 16.8889 13.1213 16.8889 10.6667V4.44444Z"
    />
    <path
      d="M16.8889 21.3333C16.8889 18.8787 18.8787 16.8889 21.3333 16.8889H27.5556C30.0102 16.8889 32 18.8787 32 21.3333V27.5556C32 30.0102 30.0102 32 27.5556 32H21.3333C18.8787 32 16.8889 30.0102 16.8889 27.5556V21.3333Z"
    />
  </svg>
</template>
